<script setup lang="ts">
defineProps<{
  messages?: string | string[]
}>()
</script>

<template>
  <div v-if="messages">
    <p class="text-sm text-red-600 dark:text-red-500">
      {{ Array.isArray(messages) ? messages.join(', ') : messages }}
    </p>
  </div>
</template>
